// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1nHB2","rootSmall":"AddTileButton_rootSmall__z5Dr1"};